import {AxiosInstance} from 'axios';
import {CustomException} from '@core/modules/common/infra/error';
import {httpMessage} from '@core/modules/common/infra/message';

import {Paths} from './keys';
import { InvoiceGateway } from '../domain/invoice.gateway';
import { InvoicesInterface } from '../domain/invoice.entities';

export class InvoiceHttpGateway implements InvoiceGateway {
    constructor(private http: AxiosInstance) {}

    async create(params: InvoicesInterface): Promise<any> {
        return this.http
            .post(Paths.default, params)
            .then((res) => {
                return res.data;
            })
            .catch((error) => {
                if (error?.status !== 409) {
                    // throw new CustomException(error?.response?.data);
                    return false
                }
                throw new CustomException(httpMessage.updateError('create invoice'));
            });
    }
}
